import {Component, EventEmitter, Input, Output} from '@angular/core';
import { DateRange } from 'src/modules/event/interfaces/date-range';

@Component({
    selector: 'time-filter',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class TimeFilter {
  @Input() dateSize: string;
  @Input() DateRange: DateRange;

  @Output() onSetDateSize: EventEmitter<any> = new EventEmitter();
  @Output() onIncrementStartDate: EventEmitter<any> = new EventEmitter();
  @Output() onDecrementStartDate: EventEmitter<any> = new EventEmitter();
  @Output() onStartDateToday: EventEmitter<any> = new EventEmitter();

  setDateSize(dateSize: any): void {
    this.onSetDateSize.emit(dateSize);
  }

  incrementStartDate(): void {
    this.onIncrementStartDate.emit();
  }

  decrementStartDate(): void {
    this.onDecrementStartDate.emit();
  }

  startDateToday(): void {
    this.onStartDateToday.emit();
  }
}
